import { render, staticRenderFns } from "./TabsDefault.vue?vue&type=template&id=fbeaa01c&"
import script from "./TabsDefault.vue?vue&type=script&lang=js&"
export * from "./TabsDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports